export interface AddressLookupSummary {
  id: string;
  address: string;
  url: string;
}
